import { IHousehold } from "../household/household";
import { ISearchResult } from "../well/search/search.result";

export interface IFuzzySearchResult {
    data: ISearchResult;
    score: number;
}

export interface IFuzzySearchHouseholdResult {
    data: IHousehold;
    score: number;
}
